import * as React from "react";
import { Button } from "azure-devops-ui/Button";

export default class CustomRenderTooltipExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <Button
                    iconProps={{ iconName: "Add" }}
                    text="This button has a custom tooltip"
                    tooltipProps={{ renderContent: this.renderCustomContent }}
                />
            </div>
        );
    }

    private renderCustomContent = () => {
        return (
            <div>
                <b>Using onRenderContent</b>
                <p style={{ margin: "2px 0px 0px" }}>
                    You may assign a function to onRenderContent to render custom content into the
                    tooltip
                </p>
            </div>
        );
    };
}
